import React from "react";
import dayjs from "dayjs";

import { s360ConfigService } from "../../Services/S360Config";

function MessageA6(props) {

  const messageContainerClassName = () => {
    return props.config.autoFullScreen
      ? "s360-message-cotainer-received-fs"
      : "s360-message-cotainer-received";
  }

  const messageBoxStyle = () => {
    return s360ConfigService.config?.customDesign?.messageA6Box;
  }

  const messageTimeStyle = () => {
    return s360ConfigService.config?.customDesign?.messageA6Time;
  }

  const videoURL = props.entry.url;
  const style = {};
  if (props.entry.data) {
    let data = JSON.parse(props.entry.data)
    style.width  = (data.width) ? (data.width+"px"): "100%";
    style.height = (data.height) ? (data.height+"px"): "100%";
  }
  return (
    <div className={messageContainerClassName()}>
      <div className="s360-message-box-custom-received" style={messageBoxStyle()}>
        <video width="100%" controls style={style}>
          <source src={videoURL}
            type="video/mp4" />
                    Sorry, your browser doesn't support embedded videos.
        </video>
      </div>
      {  props.isLastEntry && props.sentTimestamp&& <div className="s360-message-time-received" style={messageTimeStyle()}>{dayjs.unix(props.sentTimestamp).format("DD MMM h:mm a")}</div>}
    </div>
  );

}

export default MessageA6;
